import React, { Component, Suspense, lazy } from 'react'
import Helmet from 'react-helmet'
import SuspenseLoader from './../../components/suspense_loader/SuspenseLoader'
import Sidebar from './../../components/sidebar/Sidebar'

import './Standings.scss'
import HeaderTitle from '../shared/HeaderTitle'

const NBAStandings = lazy(() => import('./nba/NBAStandings'))
const WNBAStandings = lazy(() => import('./wnba/WNBAStandings'))
const NBACUPStandings = lazy(() => import('./nba-cup/NBACUPStandings'))
const NHLStandings = lazy(() => import('./nhl/NHLStandings'))
const AHLStandings = lazy(() => import('./ahl/AHLStandings'))
const MLBStandings = lazy(() => import('./mlb/MLBStandings'))
const CFLStandings = lazy(() => import('./cfl/CFLStandings'))
const NFLStandings = lazy(() => import('./nfl/NFLStandings'))

class Standings extends Component {
    render() {
        const { league, sport } = this.props.match.params
        const leagueFormatted = league.toUpperCase()

        return (
            <div className="Standings__cont standings">
                <Helmet
                    title={`${leagueFormatted} Standings - Sportsnet.ca`}
                    link={[
                        {
                            rel: 'canonical',
                            href: `${window.location.origin}/${sport}/${league}/standings`,
                        },
                    ]}
                >
                    <meta
                        name="description"
                        content={`Your source for up to date ${leagueFormatted} regular season standings.`}
                    />
                    <meta
                        name="og:url"
                        content={`${window.location.origin}/${sport}/${league}/standings`}
                    />
                    <meta name="og:title" content={`${leagueFormatted} Standings - Sportsnet.ca`} />
                    <meta
                        name="og:description"
                        content={`Your source for up to date ${leagueFormatted} regular season standings.`}
                    />
                    <meta
                        name="og:image"
                        content={`https://images.rogersdigitalmedia.com/www.sportsnet.ca/team_logos/90x90/${sport}/${league}/${league}.png`}
                    />
                </Helmet>

                <div className="inner_cont">
                    <div className="left_col">
                        {(league === 'nhl' ||
                            league === 'ahl' ||
                            league === 'mlb' ||
                            league === 'nba' ||
                            league === 'wnba' ||
                            league === 'cfl' ||
                            league === 'nfl') && (
                            <HeaderTitle title={league.toUpperCase() + ' Standings'}></HeaderTitle>
                        )}
                        {league === 'nba-cup' && (
                            <HeaderTitle title={'NBA Cup Standings'}></HeaderTitle>
                        )}

                        <Suspense fallback={<SuspenseLoader />}>
                            {league === 'nhl' && <NHLStandings {...this.props} />}
                            {league === 'ahl' && <AHLStandings {...this.props} />}
                            {league === 'mlb' && <MLBStandings {...this.props} />}
                            {league === 'nba' && <NBAStandings {...this.props} />}
                            {league === 'wnba' && <WNBAStandings {...this.props} />}
                            {league === 'nba-cup' && <NBACUPStandings {...this.props} />}
                            {league === 'cfl' && <CFLStandings {...this.props} />}
                            {league === 'nfl' && <NFLStandings {...this.props} />}
                        </Suspense>
                    </div>

                    <div className="right_col">
                        <Sidebar league={league} />
                    </div>
                </div>
            </div>
        )
    }
}

export default Standings
